import {
  LBSelect,
  LBSelectContent,
  LBSelectItem,
  LBSelectTrigger,
  LBTaskListCheckIcon
} from '@linearb/buzz';
import { useMemo } from 'react';
import { keyBy } from 'lodash';

const IterationsPicker = ({
  iterations,
  onChange,
  selectedIteration,
  disabled
}) => {
  const iterationsById = useMemo(() => keyBy(iterations, 'id'), [iterations]);

  if (!iterations?.length) return null;

  return (
    <div>
      <LBSelect
        onValueChange={iterationId => onChange(iterationsById[iterationId])}
        value={selectedIteration?.id}
        disabled={disabled}
      >
        <LBSelectTrigger className='w-auto'>
          <LBTaskListCheckIcon className='mr-2' />
          <div className='mr-2'>{selectedIteration?.computedName}</div>
        </LBSelectTrigger>
        <LBSelectContent>
          {iterations.map(iteration => (
            <LBSelectItem key={iteration.id} value={iteration.id}>
              {iteration.computedName}
            </LBSelectItem>
          ))}
        </LBSelectContent>
      </LBSelect>
    </div>
  );
};

export default IterationsPicker;
